import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyAmYpGrAQektr75raLF-mkkwkK3a5YhApk",
  authDomain: "kemiraauth.firebaseapp.com",
  projectId: "kemiraauth",
  storageBucket: "kemiraauth.firebasestorage.app",
  messagingSenderId: "409137262",
  appId: "1:409137262:web:7db066d97271425972767f",
  measurementId: "G-GGGTXL4YLY"
};

export const firebaseApp = initializeApp(firebaseConfig);
